// View Page
const DASHBOARD = {
    REQUEST: 'DASHBOARD_REQUEST',
    SUCCESS: 'DASHBOARD_SUCCESS',
    FAILURE: 'DASHBOARD_FAILURE',
    GRAPH_SUCCESS: 'DASHBOARD_GRAPH_SUCCESS',
    GRAPH_FAILURE: 'DASHBOARD_GRAPH_FAILURE',
    NOTIFICATION: 'DASHBOARD_NOTIFICATION',
    ERRORSYSTEM: 'DASHBOARD_ERRORSYSTEM',
    ERRORSYSTEM_RESET: 'DASHBOARD_ERRORSYSTEM_RESET',
    LATEST_DATA_SUCCESS: 'LATEST_DATA_SUCCESS',
    LIST_DATA_SUCCESS: 'LIST_DATA_VISITOR_SUCCESS'
}
const USER = {
    // SEARCH: 'USERS_SEARCH',
    LIST_REQUEST: 'USERS_LIST_REQUEST',
    LIST_SUCCESS: 'USERS_LIST_SUCCESS',
    LIST_FAILURE: 'USERS_LIST_FAILURE',

    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',

    FIND_REQUEST: 'USERS_FIND_REQUEST',
    FIND_SUCCESS: 'USERS_FIND_SUCCESS',
    FIND_FAILURE: 'USERS_FIND_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
    
    CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',

    RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

    USERS_COUNT_CHANGE: 'USERS_COUNT_CHANGE',
    USERS_PAGE_CHANGE: 'USERS_PAGE_CHANGE',

    USERS_SEARCH: 'USERS_SEARCH'
}
const DEVICEDATA = {
    DATA: 'DATA',
    LATEST_READING: 'DEVICEDATA_LATEST_READING',
    LAST_READING: 'DEVICEDATA_LAST_READING',
    AVERAGE_READING: 'DEVICEDATA_AVERAGE_READING',
    AVERAGE_ERROR: 'DEVICEDATA_AVERAGE_ERROR',
    TOTAL_ERROR: 'DEVICEDATA_TOTAL_ERROR'
}
const SITE = {
    DATA: 'DATA',
    LATEST_READING: 'SITE_LATEST_READING',
    LAST_READING: 'SITE_LAST_READING',
    AVERAGE_READING: 'SITE_AVERAGE_READING',
    AVERAGE_ERROR: 'SITE_AVERAGE_ERROR',
    TOTAL_ERROR: 'SITE_TOTAL_ERROR',
    LATEST_DATA_SUCCESS: 'LATEST_DATA_SUCCESS',
}
const DATAPLAN = {
    DATA: 'FENCE LIST',
    LATEST_READING: 'FENCEDATA_LATEST_READING',
    LAST_READING: 'FENCEDATA_LAST_READING',
    AVERAGE_READING: 'FENCEDATA_AVERAGE_READING',
    AVERAGE_ERROR: 'FENCEDATA_AVERAGE_ERROR',
    TOTAL_ERROR: 'FENCEDATA_TOTAL_ERROR',
    ALLDATABYID: 'ALLDATABYID'
}
const HISTORY = {
    FIND_SUCCESS: 'HISTORY_FIND_SUCCESS',
    FIND_FAILURE: 'HISTORY_FIND_FAILURE',
    // UPDATE_SUCCESS: 'HISTORY_UPDATE_SUCCESS',
    // UPDATE_FAILURE: 'HISTORY_UPDATE_FAILURE',
    LOGS_COUNT_CHANGE: 'LOGS_COUNT_CHANGE',
    LOGS_PAGE_CHANGE: 'LOGS_PAGE_CHANGE',
}
const DEVICE = {
    REGISTER_REQUEST: 'DEVICE_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'DEVICE_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'DEVICE_REGISTER_FAILURE',

    LIST_REQUEST: 'DEVICE_LIST_REQUEST',
    LIST_SUCCESS: 'DEVICE_LIST_SUCCESS',
    LIST_FAILURE: 'DEVICE_LIST_FAILURE',

    UPDATE_REQUEST: 'DEVICE_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'DEVICE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'DEVICE_UPDATE_FAILURE',

    FIND_REQUEST: 'DEVICE_FIND_REQUEST',
    FIND_SUCCESS: 'DEVICE_FIND_SUCCESS',
    FIND_FAILURE: 'DEVICE_FIND_FAILURE',

    DELETE_REQUEST: 'DEVICE_DELETE_REQUEST',
    DELETE_SUCCESS: 'DEVICE_DELETE_SUCCESS',
    DELETE_FAILURE: 'DEVICE_DELETE_FAILURE',

    INACTIVE: 'inactive',
    ACTIVE:'active',
    DISPOSE: 'dispose',

    SEARCH: 'DEVICES_SEARCH',
}

// Others
const ROLE = {
    SUPER: 'super',
    ADMIN: 'admin',
    MANAGER: 'manager'
}

const PATH = {
    LOGIN: '/login'
}

export const CONSTANTS = {
    CLEAR: 'CLEAR',
    TIME_IDLE: 30, // value in minute

    DASHBOARD,
    USER,
    DEVICEDATA,
    DEVICE,
    HISTORY,
    SITE,
    DATAPLAN,

    ROLE,
    PATH,
}